import Vue from 'vue';
import VueX from 'vuex';
// import persistedState from 'vuex-persistedstate';
Vue.use(VueX);
let Base64 = require('js-base64').Base64;
//創建 vuex實例

const state = {
    listData: {},//点左侧菜单栏存云盘根目录的信息数据
    cacheTableDatas: {},
    cacheNextPage: {}, //用于存储每个界面分页加载是否有下一页值
    pathJson: {},
    pathData: '',
    activeClass: '',
    arr: [],
    syncArr: [],
    multiSelect: '',
    syncMultiSelect: '',
    treeMoveSelect: '',
    clickItem: -1,
    syncClickItem: -1,
    leftBannerFlag: false,
    leftbannerClick: -1,
    previewData: '',
    cutArr: [],
    cutClonArr:[],//放剪切数据的克隆数据，防止界面显示
    copyArr: [],
    cutFolderId: null,
    copyFolderId: null,
    treeDriveId: null,
    transferFromOpen: null,
    tId: null,
    sourceDriveId: null,
    sourceItems: [],
    sourcePid: null,
	payUpgrade:false,
    halloweenPayUpgrade:false,//万圣节升级活动
    normalPayUpgrade:false,//普通升级
	remoteTaskArr: null,
	parseMagnet:null,
	parseMagnetName:null,
	parseMagnetCloudSite:null,
	currentParseMagnetId:-1,
    cloudExploerPasteItems: {},//每次打开界面的时候存其父节点信息
    catalogFileId: '', //用于存储其他地方跳转路径的文件/文件夹id，以便跳转后选中。
    leftbannerMenuClick: -1,
    allDrives: [], //用于存储该用户名下所有的云盘和云盘类型数据
    addCloudLineUp: [], //用于存储addCloud界面横线上方的云盘
    addCloudLineDown: [], //用于存储addCloud界面横线下方的云盘
    allCategories: [], //用于存储addCloud界面排序的云盘
    taskListArr: [], //用于存储已经分好组的任务列表的数组数据
    // taskListArrCopy:[],//用于存储已经分好组的任务列表的数组数据的复制，防止watch事件使界面显示为null
    taskListNotGropArr:[],//用于存储后端返回的还未分好组的数组
    taskListNotGropArrCopy:[],//用于存储后端返回的还未分好组的数组的复制，防止watch事件使界面显示为null
    dragFlage: false, //用于表示是否是鼠标拖拽多选事件
    childrenFlag: true, //子组件的hover事件是否生效，false表示不生效
    passWord: '', //用于存储用户的密码
    retryItems: [], //用于存储Task List重试的以及临时任务右侧列表数据,
    uploadArr:[],//上传的数组,
    detailedProgrssData: [], //用于存储Task List重试的Detail Progress数据
    notUploadFile: true,
    loadFlag: true,
    languageIndex: 0, //用于存储多语言
    exploerselectedArr: [],//copy to 时判断是否存在不支持的目标目录
    listRuningData: [], //用于页面传递正在运行的临时任务数据
    newDataFlag: false,
    cancelAllFlag: false, //用于是否显示全部取消按钮,
    haveNewSnapData: false, //用于判断是否有添加新的临时任务数据
    detaleProgressShow: false, //用于临时任务列表切换路径时是否显示
    snapTaskShow:false,
    sharesType: 0,//用户标记分享管理当前所选择的选项卡，0：myShares, 1：savedShares
    sharesPassWordJson: {},//缓存私人分享密码
    cloudCategories:[],//用于存储‘list_categories’接口返回的云盘种类
    cacheShareTableDatas: {},//用于存储分享管理界面，跳转后导航到指定位置
    detailTabSuccess:[],//用于存储成功了的临时任务
    detailTabUnfinished:[],//用于存储未完成的临时任务
    initProgressFlag:false,//初始化进度标志
    taskListFlag:false,//初始化任务是否加载完毕标志
    isTreeflage: true, //用于控制是否树形组件聚焦
    sharePath: [],//用于控制跳转分享页后，再次进入指定子目录，并选中文件
    newTaskflag:false,//标志是否有新任务产生，如果有则切换到任务列表时重新获取进度
    comeBackFileFlag:false,//用于标记是否是返回上一级目录
    openFileFlag:false,//用于标记是否是打开目录
    taskListAddNewNumber:0,//用于记录左侧菜单栏新增的任务数据条数
    videlSaverTaskListAddNewNumber:0,//用于记录左侧菜单栏新增的任务数据条数
    endIndex:0,
    datafirstIndex:0,
    teamCloud: {},//team页面cloud信息
    resetEmail:false,//用户设置临时账号是否显示
    detailTaskOpen:false,//用于标识临时任务详情是否有页面展开
    threadChange:false,//用于同步任务渲染数据
    transferDetailChange:false,//用于传输任务渲染数据
    treeRealTimeMode:false,//用于标识树形组件是否是即时同步，用于判断Box的根目录是否应该选择
    taskListSelectedArr:[],//用于看任务列表是否选中数据
    paySysRes: {},//用于paySys页面的init方法获取的信息提前缓存
    beginGuideFlag:false,//用户是否显示新手引导
    updateUserSchems: false,//是否更新用户套餐信息
    activeTags: [],//用户活动标记集合
    tabCategories: -1,//用户当前标签页分类
    imageSaverTaskDatas: [],//图片保存任务
    imageSaverDestNode: null,//图片保存目的地
    googleGuideFlag2X: 0,//谷歌相册新手引导2坐标
    googleGuideFlag2Y: 0,//谷歌相册新手引导2坐标
    googleGuideFlag2:false,//谷歌相册新手引导2
    googleGuideFlag:false,//谷歌相册新手引导
    insGuideFlag:false,//图片保存新手引导
    isInsTaskList:false,//是否是Ins任务列表
    dataFromOtherAction: "",//保存来自其他网站的传递消息，一次性使用，使用前需清空
    taskProgress: {},//任务列表进度信息
    //是否是轻模式
    isLiteMode: false,
    //是否在24小时内
    isIn24Hour: false,
    // 云盘列表
    drives: [],
    // 任务列表
    tasks: [],
    // 当前云盘ID
    curDriveId: "",
    // 当前节点
    curNode: null,
    // 当前开始位置
    curStart: null,
    // 是否需要加载
    needLoad: "",
    // 是否需要重新获取云盘信息
    needLoadDriveInfo: false,
    // lite新增任务计数
    liteFileTaskCountCopy: 0,
    liteFileTaskCountTran: 0,
    liteFileTaskCountSync: 0,
    liteFileTaskCountBackup: 0,
    liteFileTaskCountRestore: 0,
    liteFileTaskCountWebsite: 0,
    liteFileTaskCountClone: 0,
    // 宽导航
    isWidthNav: false,
    // 没有驱动器
    noneDrive: false,
    promoEndTime: 0,//促销倒计时结束时间戳
}
const actions = {

}
const mutations = {
    setChildrenFlag(state, childrenFlag) {
        state.childrenFlag = childrenFlag;
    },
    setDragFlage(state, dragFlage) {
        state.dragFlage = dragFlage;
    },
    setListData(state, listData) {
        let listDataClon = Object.assign({}, listData);
        if (listDataClon.cloud.children) {
            delete listDataClon.cloud.children;
        }
        state.listData = listDataClon;
        localStorage.setItem("listData", Base64.encode(JSON.stringify(state.listData)));
    },
    setCacheTableDatas(state, cacheTableDatas) {
        state.cacheTableDatas[cacheTableDatas.id] = cacheTableDatas;
    },
    setCacheNextPage(state, cacheNextPage) {
        state.cacheNextPage[cacheNextPage.id] = cacheNextPage;
    },
    setPathData(state, pathData) {
        state.pathData = pathData;
    },
    setPathJson(state, pathJson) {
        var arr = [];
        var i = 0;
        for (var item in state.pathJson) {
            arr[i] = item;
            i++;
        }
        if (!arr.length && localStorage.getItem("path")) {
            state.pathJson = JSON.parse(Base64.decode(localStorage.getItem("path")));
        }
        state.pathJson[pathJson.folderId] = pathJson;
        localStorage.setItem("path", Base64.encode(JSON.stringify(state.pathJson)));
    },
    setActiveClass(state, activeClass) {
        state.activeClass = activeClass;
    },
    setArr(state, arr) {
        state.arr.push(arr);
    },
    setSyncArr(state, syncArr) {
        state.syncArr.push(syncArr);
    },
    setSyncArrEmpty(state, syncArr) {
        state.syncArr = [];
    },
    setMultiSelect(state, multiSelect) {
        state.multiSelect = multiSelect;
    },
    setSyncMultiSelect(state, syncMultiSelect) {
        state.syncMultiSelect = syncMultiSelect;
    },
    setTreeMoveSelect(state, treeMoveSelect) {
        state.treeMoveSelect = treeMoveSelect;
    },
    setClickItem(state, clickItem) {
        state.clickItem = clickItem;
    },
    setSyncClickItem(state, syncClickItem) {
        state.syncClickItem = syncClickItem;
    },
    setPreviewData(state, previewData) {
        state.previewData = previewData;
        localStorage.setItem("previewData", Base64.encode(JSON.stringify(previewData)));
    },
    setCutArr(state, cutArr) {
        state.cutArr = cutArr;
    },
    setCopyArr(state, copyArr) {
        state.copyArr = copyArr;
    },
    setCutFolderId(state, cutFolderId) {
        state.cutFolderId = cutFolderId;
    },
    setCopyFolderId(state, copyFolderId) {
        state.copyFolderId = copyFolderId;
    },
    setTreeDriveId(state, treeDriveId) {
        state.treeDriveId = treeDriveId;
    },
    setTransferFromOpen(state, transferFromOpen) {
        state.transferFromOpen = transferFromOpen;
    },
    setTId(state, tId) {
        state.tId = tId;
    },
    setSourceDriveId(state, sourceDriveId) {
        state.sourceDriveId = sourceDriveId;
    },
    setSourceItems(state, sourceItems) {
        state.sourceItems = sourceItems;
    },
    setSourcePid(state, sourcePid) {
        state.sourcePid = sourcePid;
    },
    setPayUpgrade(state, payUpgrade){
    	state.payUpgrade = payUpgrade;
    },
	setRemoteTaskArr(state, remoteTaskArr){
		state.remoteTaskArr = remoteTaskArr;
	},

	setParseMagnet(state, parseMagnet){
		state.parseMagnet = parseMagnet;
	},
	setParseMagnetName(state, parseMagnetName){
		state.parseMagnetName = parseMagnetName;
	},
	setParseMagnetCloudSite(state, parseMagnetCloudSite){
		state.parseMagnetCloudSite = parseMagnetCloudSite;
	},
	setCurrentParseMagnetId(state, magnetId){
		state.currentParseMagnetId = magnetId;
	},
    setCloudExploerPasteItems(state, cloudExploerPasteItems) {
        let cloudExploerPasteItemsClon = Object.assign({}, cloudExploerPasteItems);
        if (cloudExploerPasteItemsClon.cloud && cloudExploerPasteItemsClon.cloud.children) {
            delete cloudExploerPasteItemsClon.cloud.children;
        }
        if (cloudExploerPasteItemsClon.cloud) {
            delete cloudExploerPasteItemsClon.cloud;
        }
        if (cloudExploerPasteItemsClon.children) {
            delete cloudExploerPasteItemsClon.children;
        }
        if (cloudExploerPasteItemsClon.pnode && cloudExploerPasteItemsClon.pnode.children) {
            delete cloudExploerPasteItemsClon.pnode.children;
        }
        if (cloudExploerPasteItemsClon.methods){
            delete cloudExploerPasteItemsClon.methods;
        }
        if(cloudExploerPasteItemsClon.categoryInfo&&cloudExploerPasteItemsClon.categoryInfo.methods){
            delete cloudExploerPasteItemsClon.categoryInfo.methods;
        }
        if (localStorage.getItem("cloudExploerPaste")) {
            state.cloudExploerPasteItems = JSON.parse(Base64.decode(localStorage.getItem("cloudExploerPaste")));
        }
        if (cloudExploerPasteItemsClon.appName) {
            state.cloudExploerPasteItems[cloudExploerPasteItems.rootId] = cloudExploerPasteItemsClon;
        } else {
            state.cloudExploerPasteItems[cloudExploerPasteItems.id] = cloudExploerPasteItemsClon;
        }
        localStorage.setItem("cloudExploerPaste", Base64.encode(JSON.stringify(state.cloudExploerPasteItems)));
    },
    setCatalogFileId(state, catalogFileId) {
        state.catalogFileId = catalogFileId;
    },
    setleftbannerMenuClick(state, leftbannerMenuClick) {
        state.leftbannerMenuClick = leftbannerMenuClick;
        let user=JSON.parse(localStorage.getItem("user"));
        localStorage.setItem("leftbannerMenuClick"+user.id, Base64.encode(state.leftbannerMenuClick));
    },
    setLeftBannerFlag(state, leftBannerFlag) {
        state.leftBannerFlag = leftBannerFlag;
    },
    setleftbannerClick(state, leftbannerClick) {
        state.leftbannerClick = leftbannerClick;
        let user=JSON.parse(localStorage.getItem("user"));
        localStorage.setItem("leftbannerClick"+user.id, Base64.encode(state.leftbannerClick));
    },
    setUsersDrives(state, allDrives) {
        state.allDrives = Base64.encode(JSON.stringify(allDrives));
    },
    setAddCloudLineUp(state, addCloudLineUp) {
        state.addCloudLineUp = addCloudLineUp;
    },
    setAddCloudLineDown(state, addCloudLineDown) {
        state.addCloudLineDown = addCloudLineDown;
    },
    setAllCategories(state, allCategories) {
        state.allCategories = allCategories;
    },
    setTaskListArr(state, item) {
        state.taskListArr.push(item);
    },
    setTaskListArrAll(state, item) {
        state.taskListArr = item;
    },
    setTaskListNotGropArr(state, item){
        state.taskListNotGropArr=item;
    },
    setPassWord(state, passWord) {
        state.passWord = passWord;
    },
    setRetryItems(state, retryItem) {
        state.retryItems.push(retryItem);
    },
    setDetailedProgrssData(state, detailedProgrssData) {
        state.detailedProgrssData.push(detailedProgrssData);
    },
    setRetryItemsEmpty(state, retryItem) {
        state.retryItems = retryItem;
    },
    setDetailedProgrssDataEmpty(state, detailedProgrssData) {
        state.detailedProgrssData = detailedProgrssData;
    },
    setNotUploadFile(state, notUploadFile) {
        state.notUploadFile = notUploadFile;
    },
    setExploerselectedArr(state, exploerselectedArr) {
        state.exploerselectedArr = exploerselectedArr;
    },
    setListRuningDataArr(state, listRuningData) {
        state.listRuningData = listRuningData;
    },
    setSharesType(state, sharesType) {
        state.sharesType = sharesType;
    },
    setSharesPassWordJson(state, sharesPassWordJson) {
        state.sharesPassWordJson[sharesPassWordJson.id] = sharesPassWordJson;
        localStorage.setItem("sharesPassWordJson", Base64.encode(JSON.stringify(state.sharesPassWordJson)));
    },
    setCacheShareTableDatas(state, cacheShareTableDatas) {
        state.cacheShareTableDatas = cacheShareTableDatas;
    },
    setSharePath(state, sharePath) {
        state.sharePath = sharePath;
        localStorage.setItem("sharePath", Base64.encode(JSON.stringify(state.sharePath)));
    },
    setTeamCloud(state, teamCloud) {
        state.teamCloud = teamCloud;
        localStorage.setItem("teamCloud", Base64.encode(JSON.stringify(state.teamCloud)));
    },
    setPaySysRes(state, res) {
        state.paySysRes = res;
    },
    setUpdateUserSchems(state, res) {
        state.updateUserSchems = res;
    },
    setActiveTags(state, res) {
        state.activeTags = res;
    },
    setTabCategories(state, res) {
        state.tabCategories = res;
        let user=JSON.parse(localStorage.getItem("user"));
        localStorage.setItem("tabCategories"+user.id, Base64.encode(state.tabCategories));
    },
    setDataFromOtherAction(state, res) {
        state.dataFromOtherAction = res;
    },
    setTaskProgress(state, res) {
        //深度拷贝，触发监听
        let arr = Object.assign({}, state.taskProgress);
        arr[res.id] = res;
        state.taskProgress = arr;
    },
    removeTaskProgress(state, id) {
        if(id) {
            //深度拷贝，触发监听
            let arr = Object.assign({}, state.taskProgress);
            delete arr[id];
            state.taskProgress = arr;
        }
    },
    setPromoEndTime(state, res) {
        state.promoEndTime = res;
    },
}
const getters = {
    getlistData(state) {
        if (localStorage.getItem("listData")) {
            return JSON.parse(Base64.decode(localStorage.getItem("listData")));
        } else {
            return null;
        }
    },
    getArrData(state) {
        return state.arr;
    },
    getPathJson() {
        if (localStorage.getItem("path")) {
            return JSON.parse(Base64.decode(localStorage.getItem("path")));
        } else {
            return null;
        }
    },
    getCloudExploerPasteItems() {
        if (localStorage.getItem("cloudExploerPaste")) {
            return JSON.parse(Base64.decode(localStorage.getItem("cloudExploerPaste")));
        } else {
            return null;
        }
    },
    getUsersDrives(state) {
        if (state.allDrives.length) {
            return JSON.parse(Base64.decode(state.allDrives));
        } else {
            return [];
        }
    },
    getAddCloudLineUp(state) {
      //  if(Base64.decode(state.addCloudLineUp) && Base64.decode(state.addCloudLineUp)!="undefined" && Base64.decode(state.addCloudLineUp)!='[]'){
         return state.addCloudLineUp;
       // }
    },
    getAddCloudLineDown(state) {
       // if(Base64.decode(state.addCloudLineDown) && Base64.decode(state.addCloudLineDown)!="undefined" && Base64.decode(state.addCloudLineDown)!='[]'){
        return state.addCloudLineDown;
        //}
    },
    getAllCategories(state) {
        return state.allCategories;
    },
    getTaskListArr(state) {
        return state.taskListArr;
    },
    getleftbannerMenuClick(state) {
        let user=JSON.parse(localStorage.getItem("user"));
        let leftbannerMenuClickId = localStorage.getItem("leftbannerMenuClick"+user.id);
        if(leftbannerMenuClickId) {
            return Base64.decode(leftbannerMenuClickId);
        }else {
            return state.leftbannerMenuClick;
        }
    },
    getleftbannerClick() {
        return localStorage.getItem("leftbannerClick"+user.id);
    },
    getPreviewData(state) {
        if (localStorage.getItem("previewData")) {
            return JSON.parse(Base64.decode(localStorage.getItem("previewData")));
        } else {
            return [];
        }
    },
    getCatalogFileId(state, catalogFileId) {
        return state.catalogFileId;
    },
    getSharesPassWordJson() {
        if (localStorage.getItem("sharesPassWordJson")) {
            return JSON.parse(Base64.decode(localStorage.getItem("sharesPassWordJson")));
        } else {
            return state.sharesPassWordJson;
        }
    },
    getSharePath() {
        //使用一次后清空分享路径
        if (localStorage.getItem("sharePath")) {
            return JSON.parse(Base64.decode(localStorage.getItem("sharePath")));
        } else {
            return null;
        }
    },
    getTeamCloud() {
        if (localStorage.getItem("teamCloud")) {
            return JSON.parse(Base64.decode(localStorage.getItem("teamCloud")));
        } else {
            return null;
        }
    },
    getPaySysRes(state) {
        return state.paySysRes;
    },
    getUpdateUserSchems(state) {
        return state.updateUserSchems;
    },
    getActiveTags(state) {
        return state.activeTags;
    },
    getTabCategories() {
        let user=JSON.parse(localStorage.getItem("user"));
        let tabCategoriesId = localStorage.getItem("tabCategories"+user.id);
        if(tabCategoriesId) {
            return Base64.decode(tabCategoriesId);
        }else {
            return state.tabCategories;
        }
    },
    getTaskListAddNewNumber(state) {
        return state.taskListAddNewNumber;
    },
    getImageSaverTaskAllCount() {
        return state.imageSaverTaskDatas.length;
    },
    getUnfinishImageSaverTaskCountIns() {
        var imageSaverTasks = state.imageSaverTaskDatas;
        var count = 0;
        for (var i = 0; i < imageSaverTasks.length; i++) {
            if (imageSaverTasks[i].fromType == 'instagram') {
                var status = imageSaverTasks[i].status;
                if (status == 'create' || status == 'run') {
                    count++;
                } else if (status == 'error' && imageSaverTasks[i].msg == 'limit') {
                    count++;
                }
            }
        }
        return count;
    },
    getUnfinishImageSaverTaskCountOther() {
        var imageSaverTasks = state.imageSaverTaskDatas;
        var count = 0;
        for (var i = 0; i < imageSaverTasks.length; i++) {
            if (imageSaverTasks[i].fromType != 'instagram') {
                var status = imageSaverTasks[i].status;
                if (status == 'create' || status == 'run') {
                    count++;
                } else if (status == 'error' && imageSaverTasks[i].msg == 'limit') {
                    count++;
                }
            }
        }
        return count;
    },
    getVidelSaverTaskListAddNewNumber(state) {
        return state.videlSaverTaskListAddNewNumber;
    },
    getDataFromOtherAction(state) {
        return state.dataFromOtherAction;
    },
    getTaskProgress(state) {
        return state.taskProgress;
    },
    getPromoEndTime(state) {
        return state.promoEndTime;
    },
}

const store = new VueX.Store({
    state,
    mutations: mutations,
    actions,
    getters,
    // plugins: [persistedState()]
})
export default store;



// WEBPACK FOOTER //
// ./src/store/index.js